(() => {
  const formSelector = 'form[data-type="add-to-cart-form"]';

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase('nb-NO');

  const updateCounter = (field) => {
    const wrapper = field.closest('.stinebe-personalization__field');
    const count = wrapper?.querySelector('[data-stinebe-count]');
    if (!count) return;

    if (field.hasAttribute('data-stinebe-name-list')) {
      const names = field.value
        .split(/\r?\n/)
        .map((name) => name.trim())
        .filter(Boolean);
      count.textContent = names.length;
      return;
    }

    count.textContent = field.value.length;
  };

  const clearError = (field) => {
    field.removeAttribute('aria-invalid');
    const errorId = field.getAttribute('aria-describedby')?.split(' ').find((id) => id.includes('Error'));
    if (errorId) {
      const error = document.getElementById(errorId);
      if (error) error.hidden = true;
    }
  };

  const showError = (field) => {
    field.setAttribute('aria-invalid', 'true');
    const errorId = field.getAttribute('aria-describedby')?.split(' ').find((id) => id.includes('Error'));
    if (errorId) {
      const error = document.getElementById(errorId);
      if (error) error.hidden = false;
    }
  };

  const getVariantNameValue = (personalization) => {
    const sectionId = personalization.dataset.sectionId;
    const variantPicker = sectionId ? document.getElementById(`variant-selects-${sectionId}`) : null;
    if (!variantPicker) return '';

    const checkedInput = [...variantPicker.querySelectorAll('input[data-option-name]:checked')]
      .find((input) => ['navn', 'navnevalg'].includes(normalize(input.dataset.optionName)));
    if (checkedInput) return checkedInput.value;

    const select = [...variantPicker.querySelectorAll('select')].find((item) => {
      const optionName = item.name.match(/^options\[(.+)\]$/)?.[1];
      return ['navn', 'navnevalg'].includes(normalize(optionName));
    });
    if (select) return select.value;

    return '';
  };

  const getCustomNameValue = (personalization) => {
    return personalization.querySelector('[data-stinebe-name-choice-input]:checked')?.value || '';
  };

  const updateOptionalName = (personalization) => {
    if (!personalization?.hasAttribute('data-stinebe-optional-name')) return;

    const nameFieldWrapper = personalization.querySelector('[data-stinebe-name-field]');
    const nameField = personalization.querySelector('[data-stinebe-conditional-name]');
    if (!nameFieldWrapper || !nameField) return;

    const choiceValue = personalization.hasAttribute('data-stinebe-name-variant')
      ? getVariantNameValue(personalization)
      : getCustomNameValue(personalization);

    // Dersom Shopify ennå ikke har et eget navnevalg, vises feltet som standard.
    const hasName = !choiceValue || !normalize(choiceValue).includes('uten');

    nameFieldWrapper.hidden = !hasName;
    nameField.disabled = !hasName;

    if (hasName) {
      nameField.setAttribute('data-stinebe-required', 'true');
    } else {
      nameField.removeAttribute('data-stinebe-required');
      clearError(nameField);
    }
  };

  const initializePersonalization = (scope = document) => {
    scope.querySelectorAll('[data-stinebe-personalization]').forEach((personalization) => {
      updateOptionalName(personalization);
      personalization.querySelectorAll('[data-stinebe-counter]').forEach(updateCounter);
    });
  };

  const validate = (form) => {
    const requiredFields = [...form.querySelectorAll('[data-stinebe-required="true"]:not([disabled])')];
    let firstInvalid = null;

    requiredFields.forEach((field) => {
      const hasValue = String(field.value || '').trim().length > 0;
      const valid = hasValue && (typeof field.checkValidity !== 'function' || field.checkValidity());
      if (valid) clearError(field);
      else {
        showError(field);
        if (!firstInvalid) firstInvalid = field;
      }
    });

    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  };

  document.addEventListener('input', (event) => {
    const field = event.target.closest('[data-stinebe-counter], [data-stinebe-required="true"]');
    if (!field) return;
    if (field.hasAttribute('data-stinebe-counter')) updateCounter(field);
    if (String(field.value || '').trim()) clearError(field);
  });

  document.addEventListener('change', (event) => {
    const customChoice = event.target.closest('[data-stinebe-name-choice-input]');
    if (customChoice) {
      updateOptionalName(customChoice.closest('[data-stinebe-personalization]'));
      return;
    }

    const variantControl = event.target.closest('input[data-option-name], variant-selects select');
    if (variantControl) {
      document.querySelectorAll('[data-stinebe-personalization][data-stinebe-name-variant]').forEach(updateOptionalName);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;
    if (!validate(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    initializePersonalization();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.('[data-stinebe-personalization]')) initializePersonalization(node.parentElement || node);
          else if (node.querySelector?.('[data-stinebe-personalization]')) initializePersonalization(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }, { once: true });

  document.addEventListener('shopify:section:load', (event) => initializePersonalization(event.target));
})();
